import React from 'react';

const AddPictureIcon = (props: any) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.2122 18.3521L9.94989 24.5063C9.68426 25.0074 10.0475 25.6111 10.6146 25.6111H29.7368C30.3071 25.6111 30.67 25.0014 30.3982 24.5001L24.4665 13.5606C24.1873 13.0457 23.4529 13.0332 23.1563 13.5383L19.2282 20.2282C19.0143 20.5925 18.5424 20.7093 18.1832 20.4869L14.2732 18.0649C13.903 17.8356 13.4162 17.9674 13.2122 18.3521Z"
      fill="#000000"
    />
    <circle cx="17.7785" cy="15.995" r="1.60269" fill="#000000" />
  </svg>
);

export default AddPictureIcon;
